<template>
  <el-dialog class="el-dialogs" title="审核记录" width="80%" :close-on-click-modal="false"
             :visible.sync="visible">
    <review-steps :stepsList="stepsList" :steps="steps" :disabled="disabled"></review-steps>
    <el-form size="small" :inline="true" ref="searchForm" @keyup.enter.native="refreshList(1)"
             @submit.native.prevent :model="searchForm" label-width="100px">
      <el-form-item label="关键字：" prop="keyWord">
        <el-input v-model.trim="searchForm.keyWord" maxlength="20" clearable
                  placeholder="请输入关键字(限20字)"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
        <!--                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>-->
      </el-form-item>
    </el-form>
    <el-table
        :data="dataList"
        v-loading="loading"
        size="small" height="300px"
        class="table" ref="multipleTable" row-key='id' border>
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column prop="processResult" label="审核结果" show-overflow-tooltip></el-table-column>
      <el-table-column prop="submitByName" label="审核人" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createDate" label="审核时间" show-overflow-tooltip></el-table-column>
      <el-table-column prop="processName" label="审核操作" show-overflow-tooltip></el-table-column>
      <el-table-column prop="processOpinion" label="反馈详情" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createByName" label="提交人" show-overflow-tooltip></el-table-column>
      <el-table-column prop="submitTime" label="提交时间" show-overflow-tooltip></el-table-column>
    </el-table>
    <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                @pagination="refreshList"/>
    <div slot="footer">
      <el-button size="small" @click="visible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ReviewSteps from "@/components/toExamine/reviewSteps.vue";

export default {
  name: "auditRecords",
  components: {ReviewSteps},
  data() {
    return {
      visible: false,
      steps: 2,
      disabled: false,
      stepsList: [],

      searchForm: {
        dataId: '',
        keyWord: '',
        current: 1,
        size: 20,
      },
      borrowDaysList: [],
      total: 0,

      loading: false,
      dataList: [],
    }
  },

  methods: {
    init(id) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.searchForm.resetFields()
      })
      this.searchForm.keyWord = ''
      this.dataList = []
      this.searchForm.dataId = id
      this.refreshList(1)
      this.getReviewSteps()
    },

    // 获取数据列表 current查第几页数据
    refreshList(type) {
      if (type == 1) {
        this.searchForm.current = 1
      }
      this.loading = true
      this.$axios(this.api.user.sysProcessInfoList, this.searchForm, 'post').then(data => {
        if (data && data.status) {
          this.dataList = data.data.records
          if (this.dataList.length == 0 && this.searchForm.current > 1) {
            this.searchForm.current--
            this.refreshList()
          }
          this.total = parseInt(data.data.total)
          this.loading = false
        } else {
          this.$message.error('查询失败')
        }
      })
    },

    // 重置
    reset() {
      this.$refs.searchForm.resetFields();
      this.refreshList(1)
    },


    //获取进行的步骤
    getReviewSteps() {
      // this.$axios(this.api.collection.collectionrevdprocessList, {
      //     dataId: this.id,
      //     revdBusinessId: this.revdBusinessId,
      // }, "get").then((data) => {
      //     if (data && data.status) {
      //         this.stepsList = data.data
      //         this.steps = this.stepsList.length
      //         let firstDta = 0
      //         //判断是否全是未开始的状态
      //         this.disabled = this.stepsList[0].complement == 1
      //         this.stepsList.forEach((item, index) => {
      //             if (item.complement == 1 && !firstDta) { //找到当前进行到第几步
      //                 firstDta++
      //                 this.steps = index
      //                 if (this.stepsList[index - 1].revdOperate == 2) { //判断当前进行的步骤是否被驳回
      //                     this.$set(item, 'status', 'wait')
      //                 }
      //             } else {
      //                 this.$set(item, 'status', '')
      //             }
      //         })
      //         console.log(this.stepsList)
      //     }
      // });
    },
  },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
  height: auto !important;
}
</style>